const formLabelModalSupportFiles = {
  label: 'Visibility'
};

export default formLabelModalSupportFiles;
